import { IProps as IImageProps } from 'marketing-site/src/library/elements/Image'
import { transformImage } from '../elements/ContentfulImage'
import { IResource as IContentfulResource } from 'marketing-site/@types/generated/contentful'

export interface IResource {
  type: string
  title: string
  slug: string
  description: string
  image: IImageProps
}

export function transformResource({ fields }: IContentfulResource): IResource {
  return {
    ...fields,
    image: transformImage(fields.image),
  }
}
